import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppState } from '@/store';
import { ROUTES } from '@/models/router.model';
import { selectIsAuthorized } from '../feature/selectors';
import { appCookiesStorage } from '@/utils';
import { COOKIE_KEYS } from '@/constants/cookies';

interface IUseUnauthorizedRedirect {
  pathname?: ROUTES;
}

const useUnauthorizedRedirect = ({ pathname = ROUTES.SIGN_IN }: IUseUnauthorizedRedirect) => {
  const isAuthorized = useAppState(selectIsAuthorized);
  const navigate = useNavigate();
  const location = useLocation();
  const authToken = appCookiesStorage.getItem(COOKIE_KEYS.AUTH_TOKEN);

  useEffect(() => {
    if (!isAuthorized && !authToken && (location.pathname as ROUTES) !== ROUTES.SIGN_IN) {
      navigate(pathname);
    }
  }, [isAuthorized, location, navigate, pathname]);
};

export default useUnauthorizedRedirect;
